import { toast as uiKitToast } from '@zvuk-b2b/ui-kit';
import type { ToastData, ToastOptions as UiKitToastOptions } from '@zvuk-b2b/ui-kit';

type ToastOptions = Pick<UiKitToastOptions, 'duration' | 'closeOnClick' | 'filled' | 'rootProps' | 'mode'>;

const withLegacyVariant = (variant: string, options?: ToastOptions): ToastOptions => ({
  ...options,
  mode: options?.mode ?? 'replace',
  rootProps: { ...options?.rootProps, 'data-legacy-variant': variant },
});

export const toast = {
  info: (children: ToastData['children'], options?: ToastOptions) =>
    uiKitToast.info(children, withLegacyVariant('info', options)),
  success: (children: ToastData['children'], options?: ToastOptions) =>
    uiKitToast.success(children, withLegacyVariant('success', options)),
  error: (children: ToastData['children'], options?: ToastOptions) =>
    uiKitToast.error(children, withLegacyVariant('error', options)),
  warning: (children: ToastData['children'], options?: ToastOptions) =>
    uiKitToast.warning(children, withLegacyVariant('warning', options)),
  dismiss: uiKitToast.dismiss,
};
